import React, { useState } from "react";
import OtpInput from "react-otp-input";
import { NotificationManager } from "react-notifications";
import InputField from "../technologyModal/InputFields/InputField";
import successImg from "../../images/ServiceIcons/success.svg";
// import cookie from "react-cookie";
import MainService from "../../common/MainService";
import { useHistory } from "react-router-dom";

const DESIGNATION_OPTIONS = [
  "CEO / Founder",
  "CXO / Business Head",
  "Digital / Technology Leader",
  "Operations Leader",
  "Innovation / Strategy Leader",
  "Other",
];

const INDUSTRY_OPTIONS = [
  "Agrifood",
  "Agriculture",
  "Food & Beverage",
  "Manufacturing",
  "Retail",
  "Financial Services",
  "Telecom",
  "Logistics",
  "Aquaculture",
  "Animal / Livestock",
  "CBBOs / FPO Federations / Cooperatives",
  "NGO / Development",
  "Sustainability / Climate / Impact",
  "Government / Public Sector",
  "Enterprise / Industry Network",
  "Other",
];


const FORM_STYLES = `
  .technologyModal.bd-form { color: #1F2A24; font-size: 18px; line-height: 1.6; }
  .bd-form .form-title { font-size: 22px !important; font-weight: 600 !important;
    line-height: 1.3 !important; color: #1F2A24 !important;
    margin: 0 0 20px !important; padding: 0 !important; }
  .technologyModal.bd-form .scrollableView { height: auto; min-height: 0; max-height: none;
    overflow: visible; position: static; }
  .technologyModal.bd-form form { display: block; position: static; }
  .technologyModal.bd-form .Formbutton { display: block; position: static; float: none;
    top: auto; right: auto; bottom: auto; left: auto; transform: none;
    width: 100%; margin: 24px 0 0; clear: both; }
  .bd-form label { font-size: 18px !important; font-weight: 600 !important;
    color: #1F2A24 !important; margin-bottom: 8px !important; }
  .bd-form .input-container { margin-bottom: 20px !important; }
  .bd-form input:not(.custom-otp-input), .bd-form select {
    width: 100% !important; min-height: 52px; font-size: 18px !important;
    color: #1F2A24 !important; background: #fff !important;
    border: 1px solid #CBD6CE !important; border-radius: 10px !important;
    padding: 12px 14px !important; }
  .bd-form input::placeholder { color: #5B6660 !important; opacity: 1; font-size: 18px; }
  .bd-form input:focus, .bd-form select:focus { outline: 3px solid #2F5D45 !important;
    outline-offset: 1px; border-color: #2F5D45 !important; }
  .bd-form .input-container span { font-size: 16px !important; color: #B3261E !important;
    margin-top: 6px; }
  .bd-form .Formbutton { width: 100%; min-height: 54px; font-size: 18px !important;
    font-weight: 600 !important; color: #fff !important; background: #2F5D45 !important;
    border: none !important; border-radius: 10px !important; padding: 14px 28px !important;
    cursor: pointer; transition: background 200ms ease-out; }
  .bd-form .Formbutton:hover { background: #244A37 !important; }
  .bd-form .Formbutton:focus-visible { outline: 3px solid #1F2A24; outline-offset: 2px; }
  .bd-form .resend-otp { font-size: 16px !important; color: #5B6660 !important; }
  .bd-form .resend-otp span { font-size: 16px !important; font-weight: 600;
    color: #2F5D45 !important; }
  .bd-form .resend-otp .disabled-link { color: #5B6660 !important; }
  .bd-form .container-heading1 { font-size: 30px !important; font-weight: 700 !important;
    color: #1F2A24 !important; }
  .bd-form .container-para { font-size: 18px !important; color: #1F2A24 !important; }
  @media (prefers-reduced-motion: reduce) { .bd-form .Formbutton { transition: none; } }
`;

export default function BookDemoForm({ show, onHide, href, id1, id2 }) {
  const history = useHistory();
  const [fieldValue, setFieldValue] = useState({
    company: "",
    email: "",
    phone: "",
    name: "",
    designation: "",
    industry: "",
    requesttype: "lead",
    leadType: "Demo",
    parentid: "GBR-Admin-Realm2",
  });

  const [thanksView] = useState(false);

  const [validations, setValidations] = useState({
    company: "",
    name: "",
    phone: "",
    email: "",
    designation: "",
    industry: "",
  });

  const [otpView, setOtpView] = useState(false);
  const [OTP, setOTP] = useState();
  const [OTPBtnDisabled, setOTPBtnDisabled] = useState(true);
  const handleChange = (OTP) => setOTP(OTP);
  const [clickCount] = useState(0);

  const otpVal = { phone: fieldValue.phone, otp: OTP, email: fieldValue.email };

  const validateAll = () => {
    const { company, name, email, designation, industry } = fieldValue;
    const validations = {
      company: "",
      name: "",
      email: "",
      designation: "",
      industry: "",
    };
    let isValid = true;

    if (!company) {
      validations.company = "Organisation / Company Name is required";
      isValid = false;
    }

    if (!name) {
      validations.name = "Your Name is required";
      isValid = false;
    }

    if (!email) {
      validations.email = "Business Email is required";
      isValid = false;
    }

    if (email && !/\S+@\S+\.\S+/.test(email)) {
      validations.email = "Email format must be as example@mail.com";
      isValid = false;
    }

    if (!designation) {
      validations.designation = "Please select your role / designation";
      isValid = false;
    }

    if (!industry) {
      validations.industry = "Please select your industry / organisation type";
      isValid = false;
    }

    if (!isValid) {
      setValidations(validations);
    }

    return isValid;
  };

  const validateOne = (e) => {
    const { name } = e.target;
    const value = fieldValue[name];
    let message = "";

    if (!value && name === "company") {
      message = `Organisation / Company Name is required`;
    }
    if (!value && name === "name") {
      message = `Your Name is required`;
    }
    if (!value && name === "designation") {
      message = `Please select your role / designation`;
    }
    if (!value && name === "industry") {
      message = `Please select your industry / organisation type`;
    }

    if (value && name === "email" && !/\S+@\S+\.\S+/.test(value)) {
      message = "Please enter a valid email";
    }

    setValidations({ ...validations, [name]: message });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFieldValue((prevProps) => ({
      ...prevProps,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = validateAll();

    if (!isValid) {
      return false;
    }

    timerFunction();
    const fieldValueStringify = JSON.stringify(fieldValue);
    const url = `${window.appConfig.getOtp}${window.appConfig.TokenRelam}/otp/register/${window.appConfig.clientId}/${window.appConfig.clientSecret}`;
    fetch(url, {
      method: "POST",
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
      },
      body: fieldValueStringify,
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        return res.text();
      })
      .then((result) => {
        setOtpView(true);
        return NotificationManager.success(result);
      })
      .catch((err) => {
        console.error("Error:", err);
        NotificationManager.error(
          "Something went wrong! Please try again later.",
          "Error"
        );
      });
  };

  const otpSubmitHandler = (e) => {
    e.preventDefault();

    const fieldValueStringifyOTP = JSON.stringify(otpVal);

    const url = `${window.appConfig.validateOtp}${window.appConfig.TokenRelam}/${window.appConfig.clientId}/${window.appConfig.clientSecret}`;

    fetch(url, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: fieldValueStringifyOTP,
    })
      .then((res) => res.text())
      .then((result) => {
        if (result === "OTP validated") {
          const _data = {
            source: fieldValue.email,
            destination: `${window.appConfig.TokenRelam}`,
            username: fieldValue.email,
            usertype: "",
            phone: fieldValue.phone,
            email: fieldValue.email,
            requesttype: "demo",
            json: {
              company: fieldValue.company,
              name: fieldValue.name,
              phone: fieldValue.phone,
              email: fieldValue.email,
              designation: fieldValue.designation,
              industry: fieldValue.industry,
            },
          };

          MainService.sendRequest(_data)
            .then(() => {
              setTimeout(() => {
                history.push("/");
              }, 1000);
              return NotificationManager.success(
                "Request Sent. We will get back to you soon"
              );
            })
            .catch((err) => {
              NotificationManager.error(err);
            });
        } else {
          return NotificationManager.success(result);
        }
      })
      .catch((err) => NotificationManager.error(err));
  };

  // Resend OTP

  const mobileNumber = fieldValue.phone;

  const resendOTP = (e) => {
    e.preventDefault();

    fetch(
      `${window.appConfig.resendOTP}${mobileNumber}/${window.appConfig.TokenRelam}/${window.appConfig.clientId}/${window.appConfig.clientSecret}`,
      {
        method: "POST",
        headers: {
          accept: "*/*",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: fieldValue.email }),
      }
    )
      .then((res) =>
        res.text().then((text) => {
          if (res.ok) {
            NotificationManager.success(text);
          } else {
            NotificationManager.error(text);
          }
        })
      )
      .catch((err) => console.log("err", err));
  };

  const timerFunction = () => {
    if (clickCount < 2) {
      const resendOTPTimer = setTimeout(() => {
        setOTPBtnDisabled(false);
      }, 60000);

      return () => {
        clearTimeout(resendOTPTimer);
      };
    }
  };

  const renderInput = (inputProps, index) => (
    <input
      {...inputProps}
      type="text"
      maxLength="1"
      className="custom-otp-input"
      key={index}
    />
  );

  return (
    <div className="technologyModal bd-form">
      <style>{FORM_STYLES}</style>
      {!thanksView ? (
        <h3 className="form-title mb-0 me-5">
          {!otpView ? "Please Fill the Contact Form" : "Please Enter OTP"}
        </h3>
      ) : (
        ""
      )}
      {!otpView && !thanksView ? (
        <form onSubmit={handleSubmit}>
          <div className="scrollableView">
            <div className="input-container mb-2">
              <label className="d-block mb-1">Organisation / Company Name*</label>
              <InputField
                type="text"
                name="company"
                value={fieldValue.company}
                onChange={handleInputChange}
                onBlur={validateOne}
                placeholder="Please enter organisation / company name"
                required="true"
              />
              <span className="d-block">{validations.company}</span>
            </div>

            <div className="input-container mb-2">
              <label className="d-block mb-1">Your Name*</label>
              <InputField
                type="text"
                name="name"
                value={fieldValue.name}
                onChange={handleInputChange}
                onBlur={validateOne}
                required="true"
                placeholder="Please enter your name"
              />
              <span className="d-block">{validations.name}</span>
            </div>

            <div className="input-container mb-2">
              <label className="mb-1 d-block">Your Role / Designation*</label>
              <select
                name="designation"
                value={fieldValue.designation}
                onChange={handleInputChange}
                onBlur={validateOne}
              >
                <option value="" disabled hidden>
                  Select
                </option>
                {DESIGNATION_OPTIONS.map((option) => (
                  <option value={option} key={option}>
                    {option}
                  </option>
                ))}
              </select>
              {validations.designation && (
                <span className="d-block">{validations.designation}</span>
              )}
            </div>

            <div className="input-container mb-2">
              <label className="mb-1 d-block">Business Email*</label>
              <InputField
                type="email"
                name="email"
                value={fieldValue.email}
                onChange={handleInputChange}
                onBlur={validateOne}
                required="true"
                placeholder="Please enter business email"
              />
              <span className="d-block">{validations.email}</span>
            </div>

            <div className="input-container mb-2">
              <label className="mb-1 d-block">Phone Number</label>
              <InputField
                type="phone"
                name="phone"
                value={fieldValue.phone}
                onChange={handleInputChange}
                onBlur={validateOne}
                placeholder="Please enter phone"
              />
              <span className="d-block">{validations.phone}</span>
            </div>

            <div className="input-container mb-2">
              <label className="mb-1 d-block">Industry / Organisation Type*</label>
              <select
                name="industry"
                value={fieldValue.industry}
                onChange={handleInputChange}
                onBlur={validateOne}
              >
                <option value="" disabled hidden>
                  Select
                </option>
                {INDUSTRY_OPTIONS.map((option) => (
                  <option value={option} key={option}>
                    {option}
                  </option>
                ))}
              </select>
              {validations.industry && (
                <span className="d-block">{validations.industry}</span>
              )}
            </div>
          </div>

          <button className="Formbutton" type="submit">
            Request a Demo
          </button>
        </form>
      ) : (
        <>
          {!thanksView ? (
            <form onSubmit={otpSubmitHandler} className="pe-5">
              <div className="input-container-mod">
                <div className="otp-container mb-2 ">
                  <OtpInput
                    value={OTP}
                    numInputs={6}
                    renderSeparator={<span>-</span>}
                    onChange={handleChange}
                    isInputNum={true}
                    renderInput={renderInput}
                    inputStyle={{
                      border: "1px solid #CBD6CE",
                      borderRadius: "8px",
                      width: "48px",
                      height: "52px",
                      fontSize: "20px",
                      color: "#1F2A24",
                      fontWeight: "400",
                      caretColor: "#2F5D45",
                    }}
                    focusStyle={{
                      outline: "none",
                    }}
                  />
                </div>
                <p className="mb-4 resend-otp">
                  Didn't Received OTP ?{" "}
                  <span
                    className={`${
                      OTPBtnDisabled ? "disabled-link" : "cursor-pointer "
                    } `}
                    onClick={resendOTP}
                  >
                    Resend OTP
                  </span>
                </p>
                <button className="Formbutton">Submit</button>
              </div>
            </form>
          ) : (
            <div className="thankyou-container">
              <img
                src={successImg}
                alt="Tick Mark"
                className="d-block mx-auto"
              />
              <h2 className="container-heading1 text-center">Thank You</h2>
              <p className="container-para text-center">
                Our Executive will get into contact within 48 hours.
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
}
